import { makeRequest } from '../base/axios.ts'

export default {
  fetchEmbedKey: function (timelineId) {
    const data = { timeline_id: timelineId }
    return makeRequest({
      url: '/api/v1/embed_key',
      method: 'post',
      data,
      requestId: `post-embed-key-${timelineId}`,
    })
  },
}
